var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { E_ALERT } from '../types/AlertTypes';
import { MAFIA_ACCESS_ERROR, MAFIA_AUTH_ERROR, MAFIA_CONFLICT_ERROR, MAFIA_ERROR_STATUS, MAFIA_LOGIN_ERROR, MAFIA_PAY_ERROR, MAFIA_SERVER_ERROR, } from '../types/errors';
import { ERoleTypes } from '../types';
import { get } from '../api';
const getKeyValue = (obj, key) => obj[key];
export const getErrors = (data) => {
    if (!data)
        return [{ type: E_ALERT.ERROR, message: 'Unknown error' }];
    return Object.keys(data).map((key) => 
    // console.log("utils.getErrors", getKeyValue(data, key));
    ({ type: E_ALERT.ERROR, message: getKeyValue(data, key) }));
};
export const getAlertError = (message) => ({ type: E_ALERT.ERROR, message });
export const getAlertSuccess = (message) => ({ type: E_ALERT.SUCCESS, message });
const getLoginKeyString = (key) => {
    if (key === 'username')
        return 'логин';
    if (key === 'password')
        return 'пароль';
    return '';
};
export const getMafiaErrors = (err) => {
    var _a, _b;
    const status = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
    const data = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data;
    if (data === null || data === void 0 ? void 0 : data.humanReadable) {
        return [getAlertError(data.humanReadable)];
    }
    switch (status) {
        case MAFIA_CONFLICT_ERROR:
            // 409 обрабатывается отдельно в errorHandler
            // Возвращаем undefined чтобы errorHandler знал что нужна специальная обработка
            return undefined;
        case MAFIA_SERVER_ERROR:
            return [getAlertError(`Ошибка сервера, статус ${MAFIA_SERVER_ERROR}`)];
        case MAFIA_ERROR_STATUS:
            if ((data === null || data === void 0 ? void 0 : data.code) === MAFIA_PAY_ERROR && data.players) {
                const messages = data.players.reduce((acc, player) => {
                    // console.log('Match verifyPayment map error', acc)
                    acc.push(getAlertError(`Игрок ${player.name} не оплатил игру`));
                    return acc;
                }, []);
                return messages;
            }
            return [getAlertError(data.description || data.message || '')];
        case MAFIA_AUTH_ERROR:
        case MAFIA_LOGIN_ERROR:
            return [];
        case MAFIA_ACCESS_ERROR:
            return [getAlertError(data.description || data.message || '')];
        default:
            return [getAlertError(`Ошибка ${status}`)];
    }
};
export const getPlayer = (playerId, players) => players === null || players === void 0 ? void 0 : players.find((p) => p.id === playerId);
export const digitsOnly = (e) => {
    const charCode = e.code;
    // console.log(charCode);
    if (+charCode < 48 || +charCode > 57) {
        // digits only
        e.preventDefault();
    }
};
export const getKey = () => Math.ceil(Math.random() * 1000000);
const IdDelim = '__';
export const getUniqueId = (id) => `${getKey().toString()}${IdDelim}${id}`;
export const retrieveId = (id) => id.split(IdDelim)[1];
export const auth = (code) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: `/v1/auth/exchange?exchangeCode=${code}` });
    return response;
});
/**
 * Determines which win cases are available based on alive players
 * @param players Array of match players
 * @returns Array of available win cases
 */
export const getAvailableWinCases = (players) => {
    const availableWinCases = [];
    // Get only alive players
    const alivePlayers = players.filter(player => player.isAlive);
    // Check for alive mafia members
    const hasMafia = alivePlayers.some(player => player.role === ERoleTypes.MAFIA ||
        player.role === ERoleTypes.DON ||
        player.role === ERoleTypes.CONSIGLIERE ||
        player.role === ERoleTypes.MAFIA_LADY ||
        player.role === ERoleTypes.GAG ||
        player.role === ERoleTypes.SPY);
    // Check for alive civilians
    const hasCivilians = alivePlayers.some(player => player.role === ERoleTypes.CIVILIAN ||
        player.role === ERoleTypes.SHERIFF ||
        player.role === ERoleTypes.DOCTOR ||
        player.role === ERoleTypes.LADY ||
        player.role === ERoleTypes.SWITCHMAN ||
        player.role === ERoleTypes.BOMB ||
        player.role === ERoleTypes.JAILER ||
        player.role === ERoleTypes.SAVIOR);
    // Check for alive werewolf
    const hasWerewolf = alivePlayers.some(player => player.role === ERoleTypes.WEREWOLF);
    // Check for alive anarchist (PSYCHO role represents anarchist)
    const hasAnarchist = alivePlayers.some(player => player.role === ERoleTypes.PSYCHO);
    // Add available win cases based on alive players
    if (hasMafia) {
        availableWinCases.push("MAFIA_WIN");
    }
    if (hasCivilians) {
        availableWinCases.push("CIVILIANS_WIN");
    }
    if (hasAnarchist) {
        availableWinCases.push("ANARCHIST_WIN");
    }
    if (hasWerewolf) {
        availableWinCases.push("WEREWOLF_WIN");
    }
    // Draw is always available as an option
    availableWinCases.push("DRAW");
    return availableWinCases;
};
